import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Story", to: "/story" },
  { label: "Events", to: "/events" },
  { label: "Gallery", to: "/gallery" },
  { label: "Venue", to: "/venue" },
  { label: "Guestbook", to: "/guestbook" },
];

export default function Navbar({ onOpenRsvp }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu and scroll-up on route change
  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#FBF5EA]/90 border-b border-[#EFE6D2]/70"
          : "bg-[#FBF5EA]/60 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-10 py-4 sm:py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-serif-wb text-lg sm:text-xl tracking-tight"
          style={{ color: "var(--wb-text)" }}
        >
          V <span className="italic" style={{ color: "var(--wb-primary)" }}>&</span> P
        </Link>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="text-[0.72rem] uppercase tracking-[0.22em] font-sans-wb transition-colors hover:text-[var(--wb-primary)]"
              style={({ isActive }) => ({
                color: isActive ? "var(--wb-primary)" : "var(--wb-text)",
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={onOpenRsvp}
            data-testid="nav-rsvp-button"
            className="wb-btn"
            style={{ padding: "0.55rem 1.1rem" }}
          >
            RSVP
          </button>
        </nav>

        <button
          className="md:hidden p-2"
          aria-label="Open menu"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          style={{ color: "var(--wb-text)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#FBF5EA] border-t border-[#EFE6D2] px-6 py-8 flex flex-col gap-5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-${l.label.toLowerCase()}-link`}
              className="text-[0.8rem] uppercase tracking-[0.24em]"
              style={({ isActive }) => ({
                color: isActive ? "var(--wb-primary)" : "var(--wb-text)",
              })}
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onOpenRsvp();
            }}
            data-testid="nav-mobile-rsvp-button"
            className="wb-btn self-start mt-2"
          >
            RSVP
          </button>
        </div>
      )}
    </header>
  );
}
